import { IAppConfiguration } from '@nimbus-global/features/shared/i-app.configuration';

export const AppConfiguration: IAppConfiguration = {
  baseApiUrl: '/api/',
  licenseUrl: 'https://luware.com/en/privacy-policy/',
};
